<template>
  <div>
    <div
      v-if="isDesktop"
      class="announce-bar responsive-visible desktop">
      <span class="announce-bar__content">전 기능 미리 체험해 볼 수 있는 페이지가 준비되어 있습니다.</span>
      <a
        class="link"
        href="https://admin.fiflbox.com/#/freetrial?utm_source=registerpage&utm_medium=announcementbar"
        target="_blank">
        관리자 체험 모드 시작
      </a>
    </div>
    <div
      v-else
      class="announce-bar responsive-visible mobile">
      <span class="announce-bar__content">전 기능 미리 체험해 볼 수 있는</span>
      <a
        class="link"
        href="https://admin.fiflbox.com/#/freetrial?utm_source=registerpage&utm_medium=announcementbar"
        target="_blank">
        관리자 체험 모드 시작
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DemoCenterLinkBar",
    props: {
      isDesktop: {
        type: Boolean,
        default: true,
      },
    },
  }
</script>

<style lang="scss">

</style>